module.exports = __webpack_public_path__ + "img/bg-home.6ac483bd.jpg";